import { NgZone, OnInit, ViewChild } from '@angular/core';
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MapMarker } from 'src/app/models/marker';
import { MapService } from 'src/app/services/map.service';
import { icon, ico_preview } from 'src/configs/map_configuration';
import { SearchPlaceComponent } from '../../shared/address/search-place/search-place.component';
import { SelectPoiComponent } from '../../shared/address/select-poi/select-poi.component';
import { GMapContainerComponent } from '../../shared/map/gmap-container/gmap-container.component';
import { BaseService } from 'src/app/services/base.service';

@Component({
  selector: 'app-network-coverage',
  templateUrl: './network-coverage.component.html',
  styleUrls: ['./network-coverage.component.scss']
})
export class NetworkCoverageComponent extends GMapContainerComponent implements OnInit, OnDestroy {
  public point = null;
  public pointIcon = null;
  public pointBuildingType = null;
  public canShowPon = false;
  public errorTitle: string;
  public beaResult: any;
  public pop: any;
  public wait = false;
  public coordinates_type;
  @ViewChild('searchPlace', { static: true }) searchPlace: SearchPlaceComponent;
  @ViewChild('searchPoi', { static: true }) searchPoi: SelectPoiComponent;

  constructor(public mapService: MapService,
    private router: Router, public zone: NgZone, private baseService: BaseService) {
    super(mapService, zone);
  }
  ngOnInit() {
    if (this.router.url === '/marketing/home') {
      window.location.replace(`/home`);
    }
  }

  ngOnDestroy() {
    if (this.searchBuildingPlaceholdersSubscription$ instanceof Subscription) {
      this.searchBuildingPlaceholdersSubscription$.unsubscribe();
    }
    if (this.point) {
      const marker = this.point;
      if (marker.type === 'POP') {
        marker.label = marker.label.split(' -')[0];
      }
      marker.icons = [
        { zoom_from: 1, zoom_to: 30, path: ico_preview },
      ];
      let iconMarker;
      if (icon[marker.type]) {
        if (icon[marker.type][marker.area_type])
          iconMarker = icon[marker.type][marker.area_type] ? icon[marker.type][marker.area_type] : icon[marker.type];
      }
      this.mapService.pointSaved = {
        marker: marker,
        zoom: this.map.map.getZoom(),
        icon: iconMarker
      };
    } else {
      this.mapService.pointSaved = null;
    }
    this.mapService.toastr.clear();
  }

  // Map events

  public onMapReady() {
    this.populateMapDefault(this.map.map.getZoom());
    if (this.mapService.pointSaved) {
      this.mapService.pointSaved.marker.type = 'POINT_PICKED';
      this.map.showMarkers([this.mapService.pointSaved.marker]);
      const latlng = new google.maps.LatLng(this.mapService.pointSaved.marker.coordinates.lat, this.mapService.pointSaved.marker.coordinates.lng);
      this.map.zoomToCoordinates(latlng, this.mapService.pointSaved.zoom, false);
      this.setPoint(this.mapService.pointSaved.marker, true);
      this.manageBuildingsAndClusters();
    }
  }

  public onMarkerClicked(marker) {
    this.map.removeMarkersByTypes(this.typesMarkersPointsNTW);
    const type = marker.type.split(' ')[0];
    switch (type) {
      case 'POP': this.onSelectedPop(marker); break;
      case 'cluster': this.onSelectCluster(marker); break;
      case 'FTTH': case 'MAN': this.onSelectCivic(marker); break;
      default: this.setPoint(marker, true); break;
    }
  }

  // Select point by click on map
  public onPickedClicked(picked) {
    if (this.map.map.getZoom() >= 12) {
      this.geocoder.geocode({ location: picked.latLng }, (res) => {
        picked.label = this.mapService.pointLabel(res);
        this.showToastAfterPicked(picked);
      });
    }
  }

  public onSelectedPlace(place) {
    this.wait = true;
    if (place.geometry && place.geometry.location) {
      this.map.zoomToCoordinates(place.geometry.location);
    }
    this.place = place;
    this.isPlaceSelected = true;
    const markerPlace = this.mapService.place2Marker(place, 'POINT_PLACE');
    this.map.showMarkers([markerPlace], { clearTypes: this.typesMarkersPointsNTW });
    this.setPoint(markerPlace, true);
  }

  public onSelectedCoordinates(place) {
    this.wait = true;
    this.mapService.open('loaderModal');
    if (!place || !place.coordinates) {
      this.wait = false;
      this.mapService.close('loaderModal');
      return;
    }
    if (place) {
      const p: any = place;
      this.geocoder.geocode({ location: place.coordinates, 'region': 'it' }, (results) => {
        const p1 = this.mapService.pointInfo(results);
        p.comune = p1.comune;
        p.provincia = p1.provincia;
        p.cap = p1.cap;
        p.country = p1.country;
        p.street_number = p1.street_number;
        p.street = p1.street;
        p.label = p.formatted_address;
        if (p1) {
          this.isPlaceSelected = true;
          this.map.zoomToCoordinates(place.coordinates, null, false);
          const markerPlace = this.mapService.coordinates2Marker(place, 'POINT_PLACE');
          this.point = markerPlace;
          this.map.showMarkers([markerPlace], { clearTypes: this.typesMarkersPointsNTW });
          this.setPoint(markerPlace, true);
        }
      });
    }
  }

  // Functions

  private onSelectedPop(markerPop: MapMarker) {
    const latlng = new google.maps.LatLng(markerPop.coordinates.lat, markerPop.coordinates.lng);
    this.geocoder.geocode({ location: latlng }, (res) => {
      const cloneMarkerPop = JSON.parse(JSON.stringify(markerPop));
      cloneMarkerPop.label = `${cloneMarkerPop.label} - ${this.mapService.pointLabel(res)}`;
      this.setPoint(cloneMarkerPop, false);
    });
  }

  public onClickBuilding(building) {
    const c = this.mapService.civic2Marker(building);
    this.onSelectCivic(c, false);
  }

  public onSelectCivic(markerCivic: MapMarker, checkIfMultiple = true) {
    this.wait = true;
    // markerCivic.label = this.getSingleLabel(markerCivic.label);
    const markerPoint = this.mapService.marker2MarkerPoint(markerCivic, 'POINT_CIVIC');
    if (checkIfMultiple) {
      if (this.getBuildingsByCoordinatesSubscription$ instanceof Subscription) {
        this.getBuildingsByCoordinatesSubscription$.unsubscribe();
      }
      this.getBuildingsByCoordinatesSubscription$ = this.mapService.getBuildingByCoordinates(markerCivic.coordinates.lat, markerCivic.coordinates.lng).subscribe(res => {
        // If is a multibuilding: open modal to let user choose
        if (res.results && res.results.length && res.results.length > 1) {
          this.modalBuildings = res.results;
          this.zone.run(() => {
            this.mapService.open('multiBuildingModal');
          });
          this.wait = false;
        } else {
          // if is a single building:
          this.map.showMarkers([markerPoint], { clearTypes: this.typesMarkersPointsNTW }); // add marker on map
          this.setPoint(markerPoint, false); // actually select point
          this.setPointBuildingType(markerCivic);
          this.mapService.close('multiBuildingModal');
          this.wait = false;
        }
      });
    } else {
      this.map.showMarkers([markerPoint], { clearTypes: this.typesMarkersPointsNTW });
      this.setPoint(markerPoint, false);
      this.setPointBuildingType(markerCivic);
      this.mapService.close('multiBuildingModal');
      this.wait = false;
    }
  }

  public onChangeCoordinatesFormat(e) {
    if (e.type === 'ed50') {
      this.coordinates_type = 'ED50';
    } else {
      this.coordinates_type = null;
    }
  }

  private showToastAfterPicked(picked) {
    const marker = this.mapService.picked2Marker(picked);
    this.map.showMarkers([marker], { clearTypes: ['PICKED'] });
    const iconMarker = this.mapService.pathImgsMarkers + '/maps-arrow.png';
    const message = `<p class="mt-2 mb-1">${picked.label}</p><p class="mb-0 btn-sm"><span><img src="${iconMarker}" class="toast-image" /></span></p>`;
    const toastrOptions: any = {
      enableHtml: true,
      toastClass: 'ngx-toastr whats-here',
      maxOpened: 1,
      closeButton: true,
      newestOnTop: true,
      progressBar: false,
      disableTimeOut: true,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
      preventOpenDuplicates: true,
      timeOut: 10,
    };
    this.mapService.toastr.clear();
    const toastPicked = this.mapService.toastr.info(message, '', toastrOptions);
    toastPicked.onHidden.subscribe(() => {
      this.map.removeMarkersByType('PICKED');
    });
    toastPicked.onTap.subscribe(() => {
      const markerPoint = this.mapService.marker2MarkerPoint(marker, 'POINT_PICKED');
      this.map.showMarkers([markerPoint], { clearTypes: this.typesMarkersPointsNTW });
      this.setPoint(markerPoint, false);
    });
  }

  public setPoint(marker, checkBuildings) {
    this.point = marker;
    this.searchPlace.address = marker.labelOnInput ? marker.labelOnInput : marker.label; // special case for markers that have this parameter. if they have it, treat them as coordinates.
    this.searchPlace.showCoordinatesSwitch = marker.labelOnInput ? true : false; // special case for markers that have this parameter. if they have it, treat them as coordinates.
    if (marker.type !== 'POINT_CIVIC') {
      this.pointBuildingType = null;
    }
    let latlng;
    if (marker.coordinates && marker.coordinates.lat && marker.coordinates.lng) {
      latlng = new google.maps.LatLng(marker.coordinates.lat, marker.coordinates.lng);
    } else {
      const content = 'The searched address is not in a valid format. Please select a suggested one.';
      this.baseService.showErrorMsg(content);
      this.wait = false;
    }
    this.map.map.setCenter(latlng);
    if (marker.icons) {
      const zoom = 18;
      const found = marker.icons.findIndex(i => zoom >= i.zoom_from && zoom <= i.zoom_to && (i.area_type ? i.area_type === marker.area_type : true));
      if (found >= 0) {
        this.pointIcon = marker.icons[found].path.url;
      }
    }
    if (marker.type === 'POP') {
      const pops = this.popList.filter(p => p.id === marker.id);
      this.pop = pops && pops.length ? pops[0] : null;
    } else {
      this.pop = null;
      if (checkBuildings) {
        this.checkPlaceCoordinates(marker.coordinates.lat, marker.coordinates.lng, marker)
      }
    }
    this.wait = false;
  }

  private checkPlaceCoordinates(lat, lng, place) {
    let markerCivic = null;
    const placeLat = String(lat)
    const placeLng = String(lng)
    if (this.getBuildingsByCoordinatesSubscription$ instanceof Subscription) {
      this.getBuildingsByCoordinatesSubscription$.unsubscribe();
    }
    this.getBuildingsByCoordinatesSubscription$ = this.mapService.getBuildingByCoordinates(placeLat, placeLng).subscribe(res => {
      if (res && res.results) {
        const buildings = res.results;
        if (buildings && buildings.length === 1) { // if only 1 label, select the building
          markerCivic = this.mapService.civic2Marker(buildings[0]);
        } else if (buildings && buildings.length > 1) { // if more than 1 label, choose between buildings
          const searchedCivic = place.street_number ? place.street_number : this.mapService.pointInfo([place]).street_number;
          const found = buildings.filter(b => b.indirizzo && b.indirizzo.civico === searchedCivic);
          if (searchedCivic && found && found.length && found.length > 1) {
            let foundToUse;
            const foundFtth = found.filter(e => e.tipologia_building === 'FTTH')[0];
            const foundMan = found.filter(e => e.tipologia_building === 'MAN')[0];
            foundToUse = foundFtth ? foundFtth : foundMan;
            markerCivic = foundToUse ? this.mapService.civic2Marker(foundToUse) : null;
          } else if (searchedCivic && found && found.length && found.length === 1) {
            markerCivic = found && found[0] ? this.mapService.civic2Marker(found[0]) : null;
          } else {
            this.modalBuildings = buildings;
            this.zone.run(() => {
              this.mapService.open('multiBuildingModal');
            });
          }
        }
        if (markerCivic) {
          const markerPoint = this.mapService.marker2MarkerPoint(markerCivic, 'POINT_CIVIC');
          this.setPointBuildingType(markerCivic);
          this.map.showMarkers([markerPoint], { clearTypes: this.typesMarkersPointsNTW });
          this.point = markerPoint;
          this.wait = false;
        }
        const markers = [];
        for (const civic of this.newCivics) {
          if (!markerCivic || markerCivic.id !== civic.id) {
            markers.push(this.mapService.civic2Marker(civic));
          }
        }
      }
    });
  }

  public setPointBuildingType(marker) {
    this.pointBuildingType = null;
    if (marker && marker.area_type !== 'prospect') {
      if (marker.type === 'FTTH' || marker.type === 'MAN') {
        this.pointBuildingType = 'AB';
      } else if (marker.type === 'FTTH C&D') {
        this.pointBuildingType = 'CD';
      } else {
        this.pointBuildingType = null;
      }
    }
  }

  public checkBea() {
    this.wait = true;
    this.beaResult = null;
    this.errorTitle = null;
    let req: any = {};
    let point: any;
    this.mapService.markerToRequest(this.point).subscribe(res => {
      point = this.mapService.markerToPointRequest(res);
      req = this.mapService.createRequestBody(point);
      this.sendRequest(req);
    }, () => {
      this.wait = false;
    });
  }

  public goToP2P() {
    this.router.navigateByUrl('/p2p');
  }

  private sendRequest(req) {
    this.wait = true;
    this.mapService.createBeaQuotation(req).subscribe(res => {
      this.beaResult = res;
      this.mapService.showSuccess(this.mapService.instant('GENERAL.REQ_SUCCESS'));
      this.mapService.open('resultModal');
      this.wait = false;
    }, err => {
      switch (err.status) {
        case 500: this.errorTitle = this.mapService.instant('ERROR.500_1') + '<br />' + this.mapService.instant('ERROR.500_2') + '<br />' + this.mapService.instant('ERROR.500_3'); break;
        default: this.errorTitle = this.mapService.instant('ERROR.406_1') + '<br />' + this.mapService.instant('ERROR.406_2') + '<br />' + this.mapService.instant('ERROR.406_3'); break;
      }
      this.mapService.open('errorModal');
      this.wait = false;
    });
  }

  public reset(event?) {
    this.map.removeMarkersByTypes(this.typesMarkersPointsNTW);
    this.point = null;
    this.pointBuildingType = null;
    this.pointIcon = null;
    this.searchPlace.reset();
    this.pop = null;
    this.wait = false;
  }

}
